<template>
  <div class="webcam-wrapper">
    <div class="camera-snapshot" ref="cameraSnapshot"></div>

    <section class="ev-snapshot-button-wrapper">
      <button class="ev-snapshot-button" @click="takeSnapshot()">
        <i class="fa fa-camera" aria-hidden="true"></i>
        <span>Take Photo</span>
      </button>
      <button v-if="videoSources.length > 1" class="ev-snapshot-button" @click="switchCamera()">
        <i class="ar-icon icon-video-switch" aria-hidden="true"></i>
        <span>Switch Camera</span>
      </button>
    </section>
  </div>
</template>

<script>
import OT from "@opentok/client";
import { mapGetters } from "vuex";

export default {
  name: "SnapshotComponent",
  data() {
    return {
      shapshotPublisher: null
    };
  },
  computed: {
    ...mapGetters("calls/devices", ["videoSources"])
  },
  methods: {
    takeSnapshot() {
      const base64ImageData = this.shapshotPublisher.getImgData();
      this.$emit("onShapshot", `data:image/png;base64,${base64ImageData}`);
    },
    switchCamera() {
      this.shapshotPublisher.cycleVideo();
    },
    _createSnapshotPublisher() {
      this.shapshotPublisher = OT.initPublisher(
        this.$refs.cameraSnapshot,
        {
          publishAudio: false,
          videoSource: this.$store.state.calls.devices.selectedVideoSource,
          showControls: false,
          mirror: false,
          height: "100%",
          width: "100%",
          style: {
            backgroundImageURI: "https://cdn.evessio.com/themes/common/img/profile.png"
          }
        },
        error => {
          if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
          }
        }
      );
    }
  },
  mounted() {
    this._createSnapshotPublisher();
  },
  beforeDestroy() {
    this.shapshotPublisher.destroy();
  }
};
</script>

<style>
.camera-snapshot {
  width: 100%;
  height: 100%;
}

.webcam-wrapper .ev-snapshot-button-wrapper {
  width: 100%;
  position: absolute;
  bottom: 8px;
  display: flex;
  gap: 8px;
  justify-content: center;
}

.webcam-wrapper .ev-snapshot-button-wrapper .ev-snapshot-button {
  box-shadow: 0 0 0 transparent;
  border: 0 solid transparent;
  text-shadow: 0 0 0 transparent;

  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 104px;
  height: 48px;
  font-size: 12px;
  font-weight: bold;

  border-radius: 6px;
  justify-content: center;
  transition: all 0.3s ease;
}

.webcam-wrapper .ev-snapshot-button-wrapper .ev-snapshot-button i {
  font-size: 20px;
}

.webcam-wrapper .ev-snapshot-button-wrapper .ev-snapshot-button:hover {
  background-color: rgba(0, 0, 0, 0.6);
}
</style>
